import React from "react";
import {
  ChefHat,
  ShieldCheck,
  Leaf,
  Clock3,
  Gift,
  Users,
} from "lucide-react";

const REASONS = [
  {
    id: "single-kitchen",
    Icon: ChefHat,
    title: "Single certified kitchen",
    copy:
      "Every meal is cooked in our own FSSAI-certified kitchen in Electronic City — no third-party aggregators, no cloud kitchens.",
  },
  {
    id: "diet-first",
    Icon: Leaf,
    title: "Diet-first menus",
    copy:
      "Jain, vegan, keto, halal and allergen tracks built into every menu from day one — not added as an afterthought.",
  },
  {
    id: "on-time",
    Icon: Clock3,
    title: "On-time, every time",
    copy:
      "A dedicated logistics team and temperature-controlled transport keep our on-time delivery rate above 99%.",
  },
  {
    id: "hygiene",
    Icon: ShieldCheck,
    title: "Rigorous hygiene SLAs",
    copy:
      "Labelled ingredients, gloved handling, sealed packaging and weekly audits — hospital-grade discipline, hospitality finish.",
  },
  {
    id: "relationship",
    Icon: Users,
    title: "A relationship chef",
    copy:
      "One point of contact who learns your team, your calendar and your preferences. No ticketing systems, no call centres.",
  },
  {
    id: "branded",
    Icon: Gift,
    title: "Custom-branded packaging",
    copy:
      "Your logo on our bento boxes, takeaway bags and event stations — quietly turning every meal into a brand touchpoint.",
  },
];

export default function WhyUs() {
  return (
    <section
      id="why-us"
      data-testid="why-us-section"
      className="py-28 md:py-36 bg-[#0E2238] text-[#FDFBF7] relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-12 gap-x-4 gap-y-10 md:gap-10 mb-16 md:mb-20">
          <div className="col-span-12 lg:col-span-6">
            <p className="label-eyebrow" style={{ color: "#CBA365" }}>
              06 · Why Choose Us
            </p>
            <h2 className="font-serif mt-5 text-4xl md:text-5xl lg:text-6xl leading-[1.02]">
              Six reasons the
              <br />
              <span className="italic text-[#CBA365]">right</span> offices keep
              <br />
              coming back.
            </h2>
          </div>
          <p className="col-span-12 lg:col-span-5 lg:col-start-8 text-[#FDFBF7]/70 font-light text-base md:text-[17px] leading-relaxed self-end">
            Catering is easy to start and hard to sustain. These are the
            disciplines that keep our clients with us, quarter after quarter.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#FDFBF7]/10">
          {REASONS.map((r, i) => {
            const Icon = r.Icon;
            return (
              <article
                key={r.id}
                data-testid={`why-us-card-${r.id}`}
                className="bg-[#0E2238] p-8 md:p-10 flex flex-col gap-5 hover:bg-[#122644] transition-colors duration-500"
              >
                <div className="flex items-center gap-4">
                  <span className="w-11 h-11 flex items-center justify-center border border-[#CBA365]/50 text-[#CBA365]">
                    <Icon size={20} strokeWidth={1.25} aria-hidden="true" />
                  </span>
                  <span className="text-[10px] uppercase tracking-[0.28em] text-[#FDFBF7]/40">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3 className="font-serif text-2xl md:text-[1.7rem] leading-tight text-[#FDFBF7]">
                  {r.title}
                </h3>
                <p className="text-[#FDFBF7]/70 font-light leading-relaxed text-[15px]">
                  {r.copy}
                </p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
